export default {
  username: 'Användarnamn',
  password: 'Lösenord',
  submit: 'Logga in',
  continue: 'Fortsätt utan att logga in',
  error:
    'Det finns ett fel eller så är användarnamnet eller lösenordet felaktigt.<br/> Sidan kommer att laddas om om några sekunder eller så kan du fortsätta manuellt.',
}
